import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../../_components/common/Navbar';
import SideNavBar from '../../../../_components/common/SideNavBar'
import { superAdminAreaData } from '../../OrgAdminArea/SidebarData'
import UtilityNav from '../../../../_components/common/UtilityNav'
import ModalComponent from '../../../../_components/common/Modal';
import { Table } from 'reactstrap';
import TableNew from '../../../../_components/common/Table';
import { Input } from 'reactstrap';

class UpdateLatestAssessment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orgId: 'null',
            latestAssessmentModal: false,
            navData: [],
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {
        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
    }

    onChangeOrg = (ev) => {
        this.setState({
            orgId: ev.target.value
        })
    }

    togglelatestAssessmentModal(showModal) {
        this.setState({
            latestAssessmentModal: showModal
        })
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    render() {
        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={superAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">UPDATE LATEST ASSESSMENT</h5>
                        <div className="d-flex flex-row justify-content-center">
                            <span className="col- mt-2 " > Organisation &nbsp;
                                	{/* {
                                    loading &&
                                    <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                } */}
                            </span>
                            <Input
                                value={this.state.orgId}
                                type="select" name="field"
                                bsSize="sm" className="col-2 border-1"
                                onChange={this.onChangeOrg}
                            >
                                <option value='null' key={0}>All Organisation</option>
                                <option value={1} key={1}>Organisation</option>
                                <option value={2} key={2}>Organisation 2</option>
                                <option value={3} key={3}>Organisation 3</option>
                                <option value={4} key={4}>Organisation 4</option>
                                <option value={5} key={5}>Organisation 5</option>
                                <option value={6} key={6}>Organisation 6</option>
                            </Input>
                        </div>
                        <UtilityNav
                            actionButtons={[
                                {
                                    id: 1,
                                    name: 'Update Latest Assessment',
                                    toggler: this.togglelatestAssessmentModal.bind(this),
                                    togglerModal: this.state.latestAssessmentModal,
                                    title: 'Update Latest Assessment'
                                }
                            ]}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />
                        <p className="text-center font-weight-bold ">No fresh assessments taken by any of the participants</p>
                    </div>
                </div>
            </div>
        )
    }
}



function mapStateToProps(state) {

    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';
    return {
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(UpdateLatestAssessment);



// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/UpdateLatestAssessment/index.js